import React from "react";
import StarProfile from "../components/starDetail/StarProfile";

const StarDetail = () => {
  return <StarProfile />;
};

export default StarDetail;
